import React from 'react';
import { useSelector } from 'react-redux';
import { dictionaryListcolDefs } from './dictionary-history-cols';
import { DataGrid } from '../../../components/data-grid/data-grid';
import {
  EndpointData,
  HTTPMethodType
} from '../../../components/data-grid/data-grid-utils';
import { commonEnums } from '@codametrix/ui-common';
import { Box, Button, Flex } from '@chakra-ui/react';
import { AdminListPageLayout } from '../../../components/admin-list-page-layout/admin-list-page-layout';
import { BreadCrumbsComponent } from '../../../components/breadcrumbs/breadcrumbsComponent';
import { ColDef } from '@codametrix/grid';
import { BiomeIcon, IconName } from '@codametrix/verdigris';

const { FilterTypes } = commonEnums;

type DictionaryHistoryProps = {
  downloadDictionaryByRequestID: (requestId: string) => void;
};

export const DictionaryHistory: React.FC<DictionaryHistoryProps> = props => {
  const { downloadDictionaryByRequestID } = props;
  // get idDictionary for current dictionary on state
  const idDictionary = useSelector((state: CMx.ApplicationState) => {
    return state.dictionary.selectedDictionaryId;
  });

  const filterableOptions: CMxCommonApp.FilterableOption = {
    filters: [
      {
        key: 'dictionary_id',
        terms: [idDictionary?.toString() ?? ''],
        type: FilterTypes.EQ
      }
    ]
  };

  const endpoint = () => {
    const endPoint: EndpointData = {
      endPoint: `/dictionary/request/v2?`,
      HTTPMethodType: HTTPMethodType.POST
    };
    return endPoint;
  };

  const handleDownloadDictionary = (requestId: string) => {
    downloadDictionaryByRequestID(requestId);
  };

  const updateColDefs = (columnDefs: ColDef[]) => {
    const cols = columnDefs.map((col: ColDef) => {
      let column: ColDef = { ...col };
      if (col.headerName === 'Download') {
        column = {
          ...column,
          cellRenderer: (params: any) => {
            if (
              params.data.dictionaryCsvS3Uri &&
              params.data.dictionaryCsvS3Uri.length > 0
            ) {
              return (
                <Button
                  variant="link"
                  data-dd-action-name="~download dictionary"
                  onClick={() => handleDownloadDictionary(params.data.id)}>
                  <BiomeIcon
                    iconName={IconName.Download}
                    titleText="Download"
                  />
                </Button>
              );
            } else {
              return '';
            }
          }
        };
      }
      return column;
    });

    return cols;
  };

  return (
    <AdminListPageLayout>
      <Flex flexShrink={0} marginBottom={5}>
        <BreadCrumbsComponent />
      </Flex>
      <Box flex="1 1 0" minHeight={0} display="flex" flexDirection="column">
        <DataGrid
          columnDefs={updateColDefs(dictionaryListcolDefs)}
          endpointData={endpoint()}
          serverSideInfiniteScroll
          filterableOptions={filterableOptions}
          paginationPageSize={200}                           
        />
      </Box>
    </AdminListPageLayout>
  );
};

export default DictionaryHistory;
